import { formatDate } from "@/lib/api";
import { Receipt } from "lucide-react";

const money2 = (v) => "$" + Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const RenterPaymentHistory = ({ payHistory }) => {
  if (!payHistory.length) return null;
  return (
    <div data-testid="renter-payment-history" className="mt-6 bg-white border border-line rounded-2xl p-5">
      <div className="flex items-center gap-2"><Receipt className="h-5 w-5 text-forest" /><h2 className="text-lg font-heading font-medium text-ink">Payment history</h2></div>
      <p className="text-xs text-mute mt-1">Your rent payments. Card payments include a processing fee; PayPal & Venmo don't.</p>
      <div className="mt-3 divide-y divide-line border border-line rounded-lg overflow-hidden">
        {payHistory.map((h, idx) => (
          <div key={`${h.id}-${idx}`} data-testid="renter-payment-row" className="flex items-center justify-between gap-3 px-4 py-3">
            <div className="min-w-0">
              <p className="text-sm font-medium text-ink truncate">{h.property || "Rent"}</p>
              <p className="text-xs text-mute">{h.date ? formatDate(h.date) : "—"} · <span className="capitalize">{h.method}</span>{h.card_fee > 0 ? ` · incl. ${money2(h.card_fee)} card fee` : ""}</p>
            </div>
            <div className="text-right shrink-0">
              <span className="text-sm font-semibold text-ink tabular-nums">{money2(h.amount)}</span>
              {h.card_fee > 0 && <p className="text-[11px] text-mute">{money2(h.base_amount)} rent + {money2(h.card_fee)} fee</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
